import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NkToastrComponent } from './nk-toastr/nk-toastr.component';

@NgModule({
  declarations: [NkToastrComponent],
  exports: [NkToastrComponent],
  imports: [CommonModule],
})
export class NkToastrModule {}
